import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import defaultTabs from 'src/examples/Tab/default';
import defaultStateTabs from 'src/examples/Tab/defaultState';
import defaultFullWidthTabs from 'src/examples/Tab/defaultFullWidth';
import borderBottomTabs from 'src/examples/Tab/borderBottom';
import defaultVerticalTabs from 'src/examples/Tab/defaultVertical';
import defaultFilledTabs from 'src/examples/Tab/defaultFill';
import defaultVerticalFilledTabs from 'src/examples/Tab/defaultVerticalFill';
import defaultFullWidthFilledTabs from 'src/examples/Tab/defaultFillFullWidth';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  defaultTabs,
  defaultStateTabs,
  defaultFullWidthTabs,
  borderBottomTabs,
  defaultVerticalTabs,
  defaultFilledTabs,
  defaultVerticalFilledTabs,
  defaultFullWidthFilledTabs,
  React
};